/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CanaleComunicazione } from './canale-comunicazione';


export interface TipoPraticaCanaleComunicazioneDTO { 
    id?: string;
    canale?: CanaleComunicazione;
    abilitato?: boolean;
    testo?: string;
    version?: number;
    created_at?: string;
    updated_at?: string;
}



